<div>
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Update Gateway</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
  </div>
  <div class="modal-body">
    <form [formGroup]="updateGatewayForm">
      <mat-form-field appearance="fill" style="width: 90%; margin-left: 4%;">
        <mat-label>Gateways</mat-label>
        <mat-select formControlName="gateway">
          <mat-option *ngFor='let gw of gateways' [value]="gw.name">{{ gw.name }}</mat-option>
        </mat-select>
        <mat-error *ngIf='updateGatewayForm.get("gateway").touched && updateGatewayForm.get("gateway").errors'>Required</mat-error>
      </mat-form-field>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Cancel</button>
    <button type="button" class="btn btn-primary" (click)="onSubmit(updateGatewayForm)">Update</button>
  </div>
</div>
